import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { Menu, X, PawPrint, Search } from "lucide-react";
import TodaysPick from "./TodaysPick";

const navItems = [
    { to: "/", label: "Home" },
    { to: "/blog", label: "Reviews" },
    { to: "/dogs", label: "Dogs" },
    { to: "/cats", label: "Cats" },
    { to: "/category/pet-tech", label: "Pet Tech" },
    { to: "/about", label: "About" },
];

export default function Header() {
    const [open, setOpen] = useState(false);

    return (
        <header
            data-testid="site-header"
            className="sticky top-0 z-40 backdrop-blur-xl bg-white/80 border-b border-kblborder"
        >
            <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
                <Link
                    to="/"
                    data-testid="header-logo"
                    className="flex items-center gap-2 group"
                >
                    <span className="w-9 h-9 rounded-2xl bg-kblyellow flex items-center justify-center group-hover:rotate-[-8deg] transition-transform duration-300">
                        <PawPrint className="w-5 h-5 text-kblink" strokeWidth={2.4} />
                    </span>
                    <span className="font-display font-black text-2xl tracking-tight">
                        Kiblco
                    </span>
                </Link>

                <nav className="hidden lg:flex items-center gap-1">
                    {navItems.map((n) => (
                        <NavLink
                            key={n.to}
                            to={n.to}
                            data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className={({ isActive }) =>
                                `px-4 py-2 rounded-full text-sm font-semibold transition-colors ${
                                    isActive
                                        ? "bg-kblink text-white"
                                        : "text-kblink hover:bg-kblyellow/50"
                                }`
                            }
                            end={n.to === "/"}
                        >
                            {n.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="flex items-center gap-2">
                    <Link
                        to="/search"
                        data-testid="header-search-link"
                        className="hidden sm:inline-flex w-10 h-10 items-center justify-center rounded-full hover:bg-kblyellow/50 transition-colors"
                        aria-label="Search"
                    >
                        <Search className="w-5 h-5" strokeWidth={2.2} />
                    </Link>
                    <TodaysPick />
                    <button
                        onClick={() => setOpen(!open)}
                        data-testid="header-mobile-toggle"
                        className="lg:hidden w-10 h-10 inline-flex items-center justify-center rounded-full hover:bg-kblyellow/50"
                        aria-label="Toggle menu"
                    >
                        {open ? (
                            <X className="w-5 h-5" />
                        ) : (
                            <Menu className="w-5 h-5" />
                        )}
                    </button>
                </div>
            </div>

            {open && (
                <div
                    data-testid="mobile-nav"
                    className="lg:hidden border-t border-kblborder bg-white"
                >
                    <div className="px-5 py-4 flex flex-col gap-1">
                        {navItems.map((n) => (
                            <NavLink
                                key={n.to}
                                to={n.to}
                                onClick={() => setOpen(false)}
                                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                                className={({ isActive }) =>
                                    `px-4 py-3 rounded-xl font-semibold ${
                                        isActive
                                            ? "bg-kblink text-white"
                                            : "text-kblink hover:bg-kblyellow/50"
                                    }`
                                }
                                end={n.to === "/"}
                            >
                                {n.label}
                            </NavLink>
                        ))}
                    </div>
                </div>
            )}
        </header>
    );
}
